/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_User_SettingsInputs */



/**
* | output |
* | --- |
* | "Import User Settings" |
*
* @param {Import_User_SettingsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const import_user_settings = /** @type {((inputs?: Import_User_SettingsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_User_SettingsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Importer les paramètres utilisateur")
	if (locale === "de") return /** @type {LocalizedString} */ ("Benutzereinstellungen importieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Importa impostazioni utente")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Импорт пользовательских настроек")
	if (locale === "es") return /** @type {LocalizedString} */ ("Importar configuración de usuario")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("导入用户设置")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ユーザー設定をインポート")
	if (locale === "hi") return /** @type {LocalizedString} */ ("उपयोगकर्ता सेटिंग्स आयात करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Importar configurações do usuário")
	return /** @type {LocalizedString} */ ("Import User Settings")
});